import React from 'react'
import ConnectedComponent from '../../../../shared/connecter/ConnectedComponent'
import {LevelContainer, ScoreContainer} from '../../containers/LevelContainer'


export function playerTotalGame (player) {
    const score = player.scoreBoard.reduce((prev,v)=>{
        return prev + v.value
    }, 0)

    const numberScore = player.scoreBoard.reduce((prev,v)=>{
        return prev + (/^nums/.test(v.id) ? v.value : 0 )
    }, 0)

    return score + (numberScore >= 60 ? 35 : 0)
}

class ScoreComponent extends React.Component {
    render() {
        const {player, conf} = this.props
        const bonus = conf.config.bonus || 0
        const min = conf.config.minForBonus
        const score = player.scoreBoard.reduce((prev, v) => {
            return prev + (/^nums/.test(v.id) ? v.value : 0 )
        }, 0)
        return (
            <ScoreContainer className="total">
                <span>{score + (score >= min ? bonus : 0 )}</span>
            </ScoreContainer>)
    }
}


class ScoreOtherComponent extends React.Component {
    render() {
        const {player} = this.props
        const score = player.scoreBoard.reduce((prev, v) => {
            return prev + (/^nums/.test(v.id) ? 0 : v.value )
        }, 0)
        return (
            <ScoreContainer className="total">
                <span>{score}</span>
            </ScoreContainer>)
    }
}

class TotalComponent extends React.Component {
    render() {
        const {player} = this.props
        const total = playerTotalGame(player)
        return (
            <ScoreContainer className="total">
                <span>{total}</span>
            </ScoreContainer>)
    }
}


function ScoreBonusComponent(props) {
    return (<ScoreContainer className="total">
        <span>{props.conf.config.value}</span>
    </ScoreContainer>)
}

export default class TotalLevelComponent extends ConnectedComponent {

    constructor() {
        super()
        this.subscribe('players')
    }

    render() {

        const level = this.props.level
        const scores = this.store.players.toJSON().map(player => {

            switch (level.id) {
                case 'bonus-a': {
                    return <ScoreBonusComponent key={player.id} conf={level}/>
                }
                case 'total-b': {
                    return <ScoreOtherComponent key={player.id} player={player} conf={level}/>
                }
                case 'total': {
                    return <TotalComponent key={player.id} player={player} conf={level}/>
                }
                default: {
                    return <ScoreComponent key={player.id} player={player} conf={level}/>
                }
            }
        })

        return (
            <LevelContainer className={this.props.className || null} name={level.config.name}>{scores}</LevelContainer>)
    }
}


// WEBPACK FOOTER //
// ./src/game/level/components/types/TotalLevelComponent.jsx